import axios from "axios";
import VueAxios from "vue-axios";
import mitt from "mitt";
import App from "./App";
import router from "./router/index";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import PaperDashboard from "./plugins/paperDashboard";
import firebaseMessaging from "./firebase";
import { createApp } from "vue";
import { createAuth } from "@websanova/vue-auth";
import driverAuthBearer from "@websanova/vue-auth/dist/drivers/auth/bearer.esm.js";
import driverHttpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm.js";
import driverRouterVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm.js";

import VueApexCharts from "vue3-apexcharts";

firebaseMessaging.usePublicVapidKey(
  "BJK_ewoUuukKGbXXLwJNpB_HgehVIUwNSB5eoYZzb0m3d2eR498c5EcqZ5qNO0BOXaKlIRR-E72_j2HptcSnkQk"
);

const eventBus = mitt();
const app = createApp(App);
app.config.productionTip = false;
app.config.globalProperties.eventBus = eventBus;
app.config.globalProperties.$messaging = firebaseMessaging;

app.use(PaperDashboard).use(Antd).use(VueAxios, axios);

app.provide("axios", app.config.globalProperties.axios);
axios.defaults.baseURL = "/api";
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (err) {
    if (error.response.status === 401 || error.response.status === 403) {
      this.$auth.logout().then((res) => this.$router.push("login"));
    } else if (error.response.status === 500) {
      this.$router.push("error-500");
    }
    return Promise.reject(err);
  }
);

var auth = createAuth({
  plugins: {
    http: axios,
    router: router,
  },
  drivers: {
    http: driverHttpAxios,
    auth: driverAuthBearer,
    router: driverRouterVueRouter,
  },
  options: {
    rolesKey: "type",
    notFoundRedirect: { name: "user-account" },
    loginData: { url: "c-login" },
    logoutData: { url: "auth/logout" },
    fetchData: { url: "auth/user" },

  },
});

app.use(router).use(VueApexCharts).use(auth).mount("#app");
import moment from "moment";
import 'moment/locale/vi';
moment.locale('vi-vn');